import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SjekkpunktFormComponent } from './_stand-alone/sjekkpunkt-form/sjekkpunkt-form.component';
import { DownloadAppComponent } from './_stand-alone/download-app/download-app.component';
import { EmailVerificationComponent } from './_standalone-components/email-verification/email-verification.component';
import { OrganizationEmailVerificationComponent } from './_standalone-components/organization-email-verification/organization-email-verification.component';
const routes: Routes = [
  // {
  //   path: 'sign-in',
  //   loadChildren: () => import('./sign-in/sign-in.module').then((m) => m.SignInModule),
  // },
  {
    path: 'shop',
    loadChildren: () => import('./shop/shop.module').then((m) => m.ShopModule),
  },
  {
    path: 'filer',
    loadChildren: () => import('./_stand-alone/files.module').then((m) => m.FilesModule),
  },

  {
    path: 'my-pages',
    loadChildren: () => import('./my-pages/my-pages.module').then((m) => m.MyPagesModule),
  },

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },

  {
    path: 'user/email/:email/verify/:token',
    component: EmailVerificationComponent,
  },
  {
    path: 'organization/email/:email/verify/:token',
    component: OrganizationEmailVerificationComponent,
  },

  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'sjekkpunkt',
    pathMatch: 'full',
    component: SjekkpunktFormComponent,
  },
  {
    path: 'app',
    pathMatch: 'full',
    component: DownloadAppComponent,
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
